import {BaseEntity} from "../common/base-entity";
import { CirfBrokerInfo } from './cirf-broker-info';
import {CirfUdf} from "./cirf-udf";

export const MortgageTypeValue = {
    New: 'NEW',
    Existing: 'EXISTING'
};

export class CirfMortgage extends BaseEntity {
    id: string;
    bankName: string ;
    referenceNumber: string ;
    mortgageBroker: CirfBrokerInfo = new CirfBrokerInfo();
    mortgageType: string;
    mortgageUdfs : CirfUdf[] = [];

    hasErrors: boolean;

    hasFileUpload: boolean; //ui only
    needCleanup: boolean;
    constructor(cirfMortgage?: CirfMortgage) {
        super(cirfMortgage);
        if(cirfMortgage) {
            if(cirfMortgage.mortgageBroker) {
                this.mortgageBroker = new CirfBrokerInfo(cirfMortgage.mortgageBroker);
            }
            this.mortgageUdfs = [];
            if(cirfMortgage.mortgageUdfs){
                cirfMortgage.mortgageUdfs.forEach((udf)=>{
                    this.mortgageUdfs.push(new CirfUdf(udf));
                });
            }
        }
        else{
            this.hasErrors = false;
        }
        if(!this.bankName){
            this.bankName = '';
        }
        if(!this.referenceNumber){
            this.referenceNumber = '';
        }
    }

    isNewMortgage() : boolean {
        return this.mortgageType == MortgageTypeValue.New;
    }

    isExistingMortgage() : boolean {
        return this.mortgageType == MortgageTypeValue.Existing;
    }

    get entityName() : string {
        return 'mortgage'
    }

    isMortgageUdfsEmpty(): boolean{
        return !this.mortgageUdfs || (this.mortgageUdfs.length == 0 || this.mortgageUdfs.every(item => !item.fieldValue));
    }

    isCirfMortgageEmpty() {
        return !this.bankName && !this.referenceNumber && this.mortgageBroker?.isCirfBrokerInfoEmpty() && this.isMortgageUdfsEmpty();
    }
}
